/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletIcon24Regular = forwardRef('TextBulletIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M4.5 6.627a1.627 1.627 0 1 0 0-3.254 1.627 1.627 0 0 0 0 3.254Z" }),
        React.createElement("path", { d: "M9 5a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H9.75A.75.75 0 0 1 9 5Z" }),
        React.createElement("path", { d: "M9.75 11.25a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H9.75Z" }),
        React.createElement("path", { d: "M9.75 18.25a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H9.75Z" }),
        React.createElement("path", { d: "M6.127 12a1.627 1.627 0 1 1-3.254 0 1.627 1.627 0 0 1 3.254 0Z" }),
        React.createElement("path", { d: "M4.5 20.627a1.627 1.627 0 1 0 0-3.254 1.627 1.627 0 0 0 0 3.254Z" })));
});
